<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    class="w-6 h-6"
    :stroke="color"
    :width="size"
    :height="size"
  >
    <path d="M20 7L4 7" stroke-width="1.5" stroke-linecap="round" />
    <path d="M20 12L4 12" stroke-width="1.5" stroke-linecap="round" />
    <path d="M20 17L4 17" stroke-width="1.5" stroke-linecap="round" />
  </svg>
</template>

<script setup lang="ts">

const props = withDefaults(defineProps<{
  color?: string
  size?: number | string
}>(), {
  color: 'var(--text-primary)',
  size: 24,
})
</script>
